import { ContentInSectionAction ,ContentEventSectionAction ,ContentEventParagraphSectionAction} from '../types/ContentInSectionAction';
import { ContentInSection } from '../types/ContentInSection';

interface ContentInSectionState {
    list: any,
    error: string | null,
};

const initialState: ContentInSectionState = {
    list: {},
    error: "",
};

const contentInSectionReducers = (state = initialState, action: ContentEventSectionAction) => {
    switch (action.type) {
        case 'Content_In_Section_Event': {
            return { ...state, list: action.data }
        }
        case 'Content_In_Section_Event_Error': {
            return { ...state, error: action.error }
        }
        default:
            return state;
    }
}
export  {contentInSectionReducers};